import React, { useEffect, useRef, useState } from 'react'
import dateFormat from '../../services/DateFormat.service';
import invDateFormat from '../../services/InvertDateFormat.service';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import '../../DataTableDemo.css';
import { InputNumber } from 'primereact/inputnumber';
import apis from '../../api';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './Kiosko.css'
import Maps from '../Maps/Maps';
import { Carousel } from 'primereact/carousel';
import fileToBase64 from '../../services/fileToBase64';
import { FileUpload } from 'primereact/fileupload';
import useWindowDimensions from '../hooks/useDimensions';
import Webcam from 'react-webcam';
import { Image } from 'primereact/image';
import Maps2 from '../Maps/Maps2';
import { Badge } from 'primereact/badge';
import { Checkbox } from 'primereact/checkbox';
import { Message } from 'primereact/message';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Galleria } from 'primereact/galleria';
import useNetworkStatus from '../../helpers/useNetworkStatus';
import { Password } from 'primereact/password';
import authenticationService from '../../services/authentication.service';
import { useAuthentication } from '../../session/AuthenticationProvider';
import Cookies from 'universal-cookie/es6';
import axios from 'axios';
import { saveAs } from 'file-saver';

const Kiosco = () => {

  const cookies = new Cookies();

  const [idSolicitud, setIdSolicitud] = useState("")
  const [tipo, setTipo] = useState("")
  const [consolidado, setConsolidado] = useState("")
  const [diasTiempo, setDiasTiempo] = useState("")
  const [diasDinero, setDiasDinero] = useState("")
  const [fechaInicio, setFechaInicio] = useState("")
  const [fechaFin, setFechaFin] = useState("")
  const [files, setFiles] = useState([])

  const [fechaInicioAusentismo, setFechaInicioAusentismo] = useState("")
  const [fechaFinAusentismo, setFechaFinAusentismo] = useState("")
  const [contingencia, setContingencia] = useState("")
  const [tiempo, setTiempo] = useState("")
  const [observaciones, setObservaciones] = useState("")
  const [adjunto, setAdjunto] = useState("")

  const [longitud, setLongitud] = useState(0)
  const [latitud, setLatitud] = useState(0)

  const [loadPage, setLoadPage] = useState(false)

  const [isOpenT, setIsOpenT] = React.useState(false);

  const [isOpenOptions, setIsOpenOptions] = React.useState(false);

  const [captured, setCaptured] = useState(false)
  const [loadCaptured, setLoadCaptured] = useState(false)
  const [tries, setTries] = useState(0)
  const [manual, setManual] = useState(false)

  const [dialingData, setDialingData] = useState({
    IMAGE: '',
    IMAGE64: '',
    DATE: '',
    TIME: '',
    PIN: '',
    NAME: '',
    CONTRACT_ID: '',
    INPUT: ''
  });

  const toast = useRef(null);
  const [headers, setHeaders] = useState({
    authorization: localStorage.getItem('token')
  })

  const [rows, setRows] = useState([]);
  const [products, setProducts] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const [retry, setRetry] = useState(false)

  const [inChecked, setInChecked] = useState(false)
  const [outChecked, setOutChecked] = useState(false)

  const { isOnline } = useNetworkStatus()
  const [isAvailable, setIsAvailable] = useState(localStorage.getItem('isAvailable') ? localStorage.getItem('isAvailable') : true)
  const [message, setMessage] = useState('')

  const [openLogin, setOpenLogin] = useState(false)
  const [user, setUser] = useState("")
  const [password, setPassword] = useState("")

  const [openSend, setOpenSend] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [openSendConfirm, setOpenSendConfirm] = useState(false)
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false)
  const [row, setRow] = useState({})
  const [action, setAction] = useState("")
  const [loading, setLoading] = useState(false)
  const [isEqual, setIsEqual] = useState(false)
  const [errorFile, setErrorFile] = useState("")

  const auth = useAuthentication();

  const videoConstraints = {
    width: 600,
    height: 450,
    facingMode: "user"
  };

  addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Limpiar'
  });

  useEffect(() => {
    console.log(rows)
  }, [rows])

  useEffect(() => {
    handleLocation()
  }, [])

  useEffect(() => {
    if (localStorage.getItem('hasKiosko') !== 'S') {
      authenticationService.signOut();
      auth.logout();
    }
  }, [])

  useEffect(() => {
    if (!localStorage.getItem('isAvailable')) {
      setIsAvailable(true)
    }
  }, [localStorage.getItem('isAvailable')])

  useEffect(() => {
    setTabla()
    let now = Date.now()
    let expiration = parseInt(localStorage.getItem('expired')) + (parseInt(localStorage.getItem('expiration')) + 1) * 1000
    if (localStorage.getItem('pendingTracking')) {
      if (isOnline && isAvailable) {
        console.log(new Date(expiration), new Date(now))
        if (expiration > now) {
          console.log("asasjkfjf")
          postTrackingOffline()
        }
        else {
          showModal()
        }
      }
    }
    else {
      if (isOnline && isAvailable) {
        if (expiration < now) {
          showModal()
        }
      }
    }
  }, [isOnline, isAvailable])

  useEffect(() => {
    setHeaders({
      ...headers,
      authorization: localStorage.getItem('token')
    })
  }, [localStorage.getItem('token')])

  const showModal = () => {
    setOpenLogin(true)
  }

  const hideModal = () => {
    setOpenLogin(false)
    setUser("")
    setPassword("")
    // if (isEqual) {
    //   clear()
    // }
  }

  const showSendModal = () => {
    setOpenSend(true)
  }

  const hideSendModal = () => {
    setUser("")
    setPassword("")
    setOpenSend(false)
  }

  const showDeleteModal = () => {
    setOpenDelete(true)
  }

  const hideDeleteModal = () => {
    setUser("")
    setPassword("")
    setOpenDelete(false)
  }

  const showSendConfirmModal = () => {
    setOpenSendConfirm(true)
  }

  const hideSendConfirmModal = () => {
    setOpenSendConfirm(false)
  }

  const showDeleteConfirmModal = () => {
    setOpenDeleteConfirm(true)
  }

  const hideDeleteConfirmModal = () => {
    setOpenDeleteConfirm(false)
  }

  const hideModalT = () => {
    setIsOpenT(false);
    setManual(false)
    setInChecked(false)
    setOutChecked(false)
    setDialingData({
      ...dialingData,
      IMAGE: "",
      IMAGE64: "",
      INPUT: ""
    })
    setLatitud('')
    setLongitud('')
    setInChecked(false)
    setOutChecked(false)
    limpiar();
    console.log(dialingData)
  };

  const showModalOptions = () => {
    // if (!listasCargadas) {
    //   setListas()
    // }
    setIsOpenOptions(true);
  };

  const hideModalOptions = () => {
    setIsOpenOptions(false);
    limpiar();
  };


  //Evento para cambiar de pagina
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }
  //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila

  //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
  const renderHeader1 = () => {
    return (
      <div className="barra3">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter1} />
        <div>
          <Button icon="pi pi-check" className="p-button-success mr-2 p-button-sm text-xs" label='Enviar'
            tooltip="Enviar todos" tooltipOptions={{ position: 'top' }} disabled={!isOnline || !isAvailable}
            onClick={() => {
              setAction('all'); showSendModal()
            }} />
          <Button icon="pi pi-times" className="mr-2 p-button-danger p-button-sm text-xs" tooltip="Eliminar todos" tooltipOptions={{ position: 'top' }}
            disabled={!isOnline || !isAvailable} label='Eliminar'
            onClick={() => {
              setAction('all'); showDeleteModal()
            }} />
        </div>
      </div>
    )
  }

  //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;
    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  //Limpiar e inicializar los filtros
  const clearFilter1 = () => {
    initFilters1();
  }

  //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
  const header1 = renderHeader1();

  //Limpiar filtros de la tabla
  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'PIN': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'TIME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'INPUT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    });
    setGlobalFilterValue1('');
  }

  //Nombre de las opciciones para los filtros
  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  function handleLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(success, error);
    } else {
      console.log("Geolocation not supported");
    }
  }

  function success(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    setLatitud(latitude);
    setLongitud(longitude);
  }

  function error() {
    console.log("No se puede obtener la localizacion");
  }

  async function limpiar() {
    // setConsolidado("");
    setDiasTiempo("");
    setDiasDinero("");
    setFechaInicio("");
    setFechaFin("");
    setFechaInicioAusentismo("");
    setFechaFinAusentismo("");
    setContingencia("");
    setTiempo("");
    setObservaciones("");
    setTipo("")
    setAdjunto("")
    setUser("")
    setPassword("")
    setDialingData({
      ...dialingData,
      DATE: '',
      TIME: '',
      PIN: '',
      NAME: '',
      CONTRACT_ID: '',
      IMAGE: '',
      INPUT: ''
    });
    setCaptured(false)
    setLoadCaptured(false)
  }

  const setTabla = async () => {
    console.log("Si está")
    const pendingTracking = localStorage.getItem('pendingTracking') ? JSON.parse(localStorage.getItem('pendingTracking')) : []
    if (pendingTracking.length > 0) {
      let newRows = []
      pendingTracking.forEach((pend, index) => {
        if (pend.USER === localStorage.getItem('user')) {
          newRows.push({ ...pend, ID: index })
        }
      })
      // localStorage.setItem('pendingTracking', JSON.stringify(newRows))
      setRows(newRows)
      setLoadPage(true)
    }
    else {
      setRows([])
      setLoadPage(true)
    }
  }

  const facialRecognition = async (image) => {
    setRetry(false)
    let dateTime = getDateTime(new Date());
    let newImage = image.split(',')[1]
    const payload = {
      ENTITY: localStorage.getItem('entity'),
      CLIENT: localStorage.getItem('client'),
      IMAGE: newImage,
      TOKEN: localStorage.getItem('token')
    }
    const headers_ = {
      authorization: localStorage.getItem('token')
    }
    try {
      await apis.postImageRecognition(payload, headers_).then(res => {
        setIsAvailable(true)
        localStorage.removeItem('isAvailable')
        handleLocation()
        let data = res.data
        setDialingData({
          ...dialingData,
          IMAGE: image,
          CONTRACT_ID: data.CONTRACT_ID,
          NAME: data.NAME,
          DATE: dateTime.DATE,
          TIME: dateTime.TIME,
          PIN: data.PIN
        })
        if (!data.PIN) {
          setTries(tries + 1)
          toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'No fuiste reconocido, intentalo nuevamente', sticky: true });
        }
        else {
          setTries(0)
        }
      })
    }
    catch (err) {
      console.log(err.response.data)
      if (err.response.data.code === 403) {
        setIsAvailable(false)
        localStorage.setItem('isAvailable', false)
        setMessage(err.response.data.message)
      }
      else {
        setIsAvailable(true)
        localStorage.removeItem('isAvailable')
        setMessage('')
      }
      setDialingData({
        ...dialingData,
        DATE: dateTime.DATE,
        TIME: dateTime.TIME
      })
      if (tries === 3) {
        setTries(0)
      }
      else {
        setTries(tries + 1)
      }
    }
  }

  const getDateTime = (date) => {
    let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate().toString()
    let month = Number(date.getMonth() + 1) > 9 ? Number(date.getMonth() + 1).toString() : '0' + Number(date.getMonth() + 1).toString()
    let dateString = day + '-' + month + '-' + date.getFullYear();
    let hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
    let minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
    let seconds = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
    let hourString = hours + ':' + minutes + ':' + seconds;

    return {
      DATE: dateString,
      TIME: hourString
    };
  }

  const postTrackingNovelty = async (dialingData) => {
    setLoadCaptured(true)
    let dateTime = getDateTime(new Date());
    const payload = {
      ...dialingData,
      GEOLOCATION: {
        LAT: latitud,
        LON: longitud
      },
      IMAGE: dialingData.IMAGE.split(',')[1],
      INPUT: dialingData.INPUT,
      TOKEN: localStorage.getItem('token'),
      ENTITY: localStorage.getItem('entity'),
      CLIENT: localStorage.getItem('client'),
      CONTRACT_ID: dialingData.CONTRACT_ID,
      IMAGE64: dialingData.IMAGE64 ? dialingData.IMAGE64 : "",
      SOURCE: 'SELF',
      METHOD: 'AUT',
      DATE: isOnline && isAvailable ? dialingData.DATE : dateTime.DATE,
      TIME: isOnline && isAvailable ? dialingData.TIME : dateTime.TIME
    }
    const headers_ = {
      authorization: localStorage.getItem('token')
    }
    try {
      await apis.postTrackingNovelty(payload, headers_).then(res => {
        setIsAvailable(true)
        localStorage.removeItem('isAvailable')
        let dateTime = res.data.DATE.split(" ");
        setDialingData({
          ...dialingData,
          DATE: dateTime[0],
          TIME: dateTime[1]
        })
        setCaptured(true)
        setLoadCaptured(false)
        deleteTracking(dialingData)
        setManual(false)
        setTries(0)
        hideSendConfirmModal()
        setInChecked(false)
        setOutChecked(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Novedad creada exitosamente' });
        setTimeout(() => {
          limpiar()
          toast.current.show({ severity: 'info', summary: 'Información', detail: 'Listo para capturar' });
        }, 5000)
      })
    }
    catch (err) {
      console.log(err.response)
      if (err.response?.data.code === 403) {
        setIsAvailable(false)
        localStorage.setItem('isAvailable', false)
        setMessage(err.response.data.message)
      }
      else {
        setIsAvailable(true)
        localStorage.removeItem('isAvailable')
        setMessage('')
      }
      let msg = isOnline && isAvailable ? err.response.data.message : "No hay conexión o el servicio no está disponible, pero su marcación se enviará una vez sea reestablecido"
      setLoadCaptured(false)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: msg, life: 4000 });
      if (!isOnline || !isAvailable) {
        setManual(false)
        setTries(0)
        setCaptured(true)
        setDialingData({
          ...dialingData,
          DATE: dateTime.DATE,
          TIME: dateTime.TIME
        })
        let arr = []
        if (localStorage.getItem('pendingTracking')) {
          arr = [...JSON.parse(localStorage.getItem('pendingTracking'))]
        }
        arr.push({ ...dialingData, USER: localStorage.getItem('user').toLowerCase() })
        localStorage.setItem("pendingTracking", JSON.stringify(arr))
        setTimeout(() => {
          setInChecked(false)
          setOutChecked(false)
          setTabla()
          limpiar()
          toast.current.show({ severity: 'info', summary: 'Información', detail: 'Listo para capturar' });
        }, 5000)
      }
      throw err
    }
  }

  async function loadError(lines) {
    /*Función encargada de gnerar el archivo txt de errores del cargue*/
    const blob = new Blob([lines], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
    saveAs(blob, "errores.txt");
  }

  const postTrackingOffline = async () => {
    const pending = localStorage.getItem('pendingTracking') ? [...JSON.parse(localStorage.getItem('pendingTracking'))] : []
    let successful = 0
    let erros = 0
    let successMsg = ''
    let errorMsg = ''
    let errorLogs = []
    let errorFile_ = ""
    setLoadPage(false)
    try {

      if (pending.length > 0) {
        for (const pend of pending) {
          if (pend.USER === localStorage.getItem('user')) {
            try {
              await postTrackingNovelty(pend)
              successful++
            }
            catch (err) {
              console.log(err)
              errorLogs.push(err.response?.data?.message)
              erros++
            }
          }
        }
        let msg = []
        successMsg = successful > 0 ? successful.toString() + ' marcación(es) exitosa(s).' : ''
        if (successMsg) {
          msg.push(successMsg)
        }
        errorMsg = erros > 0 ? erros.toString() + ' marcación(es) fallida(s).' : ''
        if (errorMsg) {
          msg.push(errorMsg)
          if (errorLogs.length > 0) {
            msg = [...msg, "Valida los errores en el archivo decargado errores.txt"]
            errorFile_ = ["Errores: ", ...errorLogs].join('\n')
            setErrorFile(errorFile_)
            loadError(errorFile_)
          }
        }
        let infoMsg = msg.join('\n')
        hideSendConfirmModal()
        setLoadPage(true)
        toast.current.show({ severity: 'info', summary: 'Información', detail: infoMsg, sticky: true })
      }
    }
    catch (err) {
      console.log(err)
      setLoadPage(true)
    }
  }

  const deleteTracking = (rowData) => {
    const pending = rows
    let pendingCopy = pending
    if (pending.length > 0) {
      pending.forEach((pend, index) => {
        let pendCopy = pend
        delete pendCopy.ID
        if (JSON.stringify(pendCopy) === JSON.stringify(rowData)) {
          console.log("Es igual")
          pendingCopy.splice(index, 1)
        }
      })
      if (pendingCopy.length > 0) {
        localStorage.setItem('pendingTracking', JSON.stringify(pendingCopy))
        setRows(pendingCopy)
      }
      else {
        localStorage.removeItem('pendingTracking')
        setRows([])
      }
      hideDeleteConfirmModal()
      setTabla()
    }
  }

  const deleteAllTracking = () => {
    localStorage.removeItem('pendingTracking')
    hideDeleteConfirmModal()
    setTabla()
  }

  const clear = () => {
    authenticationService.signOut();
    auth.logout();
  }

  const login = async (type) => {
    if (user.toLowerCase() === localStorage.getItem('user').toLowerCase()) {
      console.log(user)
      setLoading(true)
      let payload = {
        username: user,
        password: password
      }
      try {
        await apis.postLogin(payload).then(data => {
          console.log(data.data)
          cookies.set('token', data.data["authorization"], { expires: new Date(Date.now() + data.data["expiration"] * 1000) })
          console.log(cookies.get('token'))
          localStorage.setItem('user', payload.username.toLowerCase());
          localStorage.setItem('expired', Date.now());
          localStorage.setItem('token', data.data["authorization"]);
          localStorage.setItem('number_id', data.data.number_id);
          localStorage.setItem('enabled', data.data.enabled);
          let route = data.data.endpoint + ':' + data.data.port
          let routeSelf = data.data.endpoint + ':9095'
          localStorage.setItem('routerApi', route);
          localStorage.setItem('selfApi', routeSelf);
          localStorage.setItem("type", data.data.type_user)
          localStorage.setItem("enabled", data.data.enabled)
          localStorage.setItem("entity", data.data.entity)
          localStorage.setItem("client", data.data.client)
          localStorage.setItem("terms", data.data.terms)
          localStorage.setItem("number_id", data.data.number_id)
          localStorage.setItem("contract_id", data.data.contract_id)
          localStorage.setItem("novelties", data.data.novelties_module)
          localStorage.setItem("instance", data.data.instance)
          localStorage.setItem("logo", data.data.logo)
          localStorage.setItem("pin", data.data.pin)
          localStorage.setItem("expiration", data.data["expiration"])
          // localStorage.setItem("contracts", JSON.stringify(data.data.contracts))
          const headers = {
            authorization: data.data["authorization"]
          }
          try {
            apis.getUserType(headers).then(res => {
              console.log(res.data)
              if (res.data) {
                setIsAvailable(true)
                localStorage.removeItem('isAvailable')
                localStorage.setItem("hasKiosko", res.data.KIOSKO)
                localStorage.setItem("turns", res.data.TURNS)
                localStorage.setItem("turns_approver", res.data.TURNS_APPROVER)
                localStorage.setItem("options_web", JSON.stringify(res.data.OPTIONS_WEB))
                setLoading(false)
                hideModal()
                hideSendModal()
                hideDeleteModal()
                setUser("")
                setPassword("")
                console.log(localStorage.getItem('hasKiosko'))
                if (res.data.KIOSKO === 'S') {
                  switch (type) {
                    case 'send':
                      showSendConfirmModal()
                      break;
                    case 'delete':
                      showDeleteConfirmModal()
                      break;
                    default:
                      toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Validación exitosa" });
                  }
                }
                else {
                  setLoading(false)
                  toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "No autorizado" });
                }
              }
            })
          }
          catch (err) {
            if (err.response.data.code === 403) {
              setIsAvailable(false)
              localStorage.setItem('isAvailable', false)
              setMessage(err.response.data.message)
            }
            else {
              setIsAvailable(true)
              localStorage.removeItem('isAvailable')
              setMessage('')
            }
            setLoading(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al validar" });
          }
        })
      }
      catch (err) {
        if (err.response.data.code === 403) {
          setIsAvailable(false)
          localStorage.setItem('isAvailable', false)
          setMessage(err.response.data.message)
        }
        else {
          setIsAvailable(true)
          localStorage.removeItem('isAvailable')
          setMessage('')
        }
        setLoading(false)
        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al validar" });
      }
    }
    else {
      setLoading(false)
      setIsEqual(true)
      toast.current.show({
        severity: 'warn', summary: 'Aviso', sticky: true,
        content: (props) => (
          <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
            <div className="font-medium text-md my-3">El usuario ingresado no coincide con el usuario de Kiosko. Si desea iniciar sesión con otro usuario, presione el botón de abajo:</div>
            <Button className="p-button-sm flex" label="Ir a iniciar sesión" severity="warning" onClick={clear}></Button>
          </div>
        )
      });
    }
  }
  const header = (
    <div>
      <h3>Validar credenciales</h3>
    </div>
  );

  const loginFooter = (
    <div>
      <Button icon="pi pi-times" className="p-button-danger mr-2 p-button-sm text-xs"
        label="Cancelar"
        onClick={() => {
          hideModal();
        }} />
      <Button icon="pi pi-check" className="mr-2 p-button-success p-button-sm text-xs" label="Validar"
        disabled={!user || !password} loading={loading}
        onClick={() => {
          login('login')
        }} />
    </div>
  );

  const sendFooter = (
    <div>
      <Button icon="pi pi-times" className="p-button-danger mr-2 p-button-sm text-xs"
        label="Cancelar"
        onClick={() => {
          hideSendModal();
        }} />
      <Button icon="pi pi-check" className="mr-2 p-button-success p-button-sm text-xs" label="Validar"
        disabled={!user || !password} loading={loading}
        onClick={() => {
          login('send')
        }} />
    </div>
  );

  const deleteFooter = (
    <div>
      <Button icon="pi pi-times" className="p-button-danger mr-2 p-button-sm text-xs"
        label="Cancelar"
        onClick={() => {
          hideDeleteModal();
        }} />
      <Button icon="pi pi-check" className="mr-2 p-button-success p-button-sm text-xs" label="Validar"
        disabled={!user || !password} loading={loading}
        onClick={() => {
          login('delete')
        }} />
    </div>
  );

  const sendConfirmHeader = (
    <div>
      <h3>Enviar marcación(es)</h3>
    </div>
  );

  const deleteConfirmHeader = (
    <div>
      <h3>Eliminar marcación(es)</h3>
    </div>
  );

  const sendConfirmFooter = (
    <div>
      <Button icon="pi pi-times" className="mr-2 p-button-sm text-xs"
        label="Cancelar"
        onClick={() => {
          hideSendConfirmModal();
        }} />
      <Button icon="pi pi-check" className="mr-2 p-button-success p-button-sm text-xs" label="Enviar"
        onClick={() => {
          if (action === 'single') {
            postTrackingNovelty(row)
          }
          else {
            postTrackingOffline()
          }
        }} />
    </div>
  );

  const deleteConfirmFooter = (
    <div>
      <Button icon="pi pi-times" className="mr-2 p-button-sm text-xs"
        label="Cancelar"
        onClick={() => {
          hideDeleteConfirmModal();
        }} />
      <Button icon="pi pi-check" className="mr-2 p-button-danger p-button-sm text-xs" label="Eliminar"
        onClick={() => {
          if (action === 'single') {
            deleteTracking(row)
          }
          else {
            deleteAllTracking()
          }
        }} />
    </div>
  );

  const photoBodyTemplate = (rowData) => {
    let photo = rowData.IMAGE ? rowData.IMAGE : process.env.REACT_APP_PROFILE_PIC
    return (
      <div className='flex flex-row align-items-center justify-content-start gap-1'>
        <img alt={""} loading='eager' src={photo} width={80} height={50} style={{ verticalAlign: 'middle' }} />
      </div>
    );
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <Button icon="pi pi-check" className="p-button-success mr-2 p-button-sm text-xs"
          tooltip="Enviar" tooltipOptions={{ position: 'top' }} disabled={!isOnline || !isAvailable}
          onClick={() => {
            setRow(rowData); setAction('single'); showSendModal()
          }} />
        <Button icon="pi pi-times" className="mr-2 p-button-danger p-button-sm text-xs" tooltip="Eliminar" tooltipOptions={{ position: 'top' }}
          disabled={!isOnline || !isAvailable}
          onClick={() => {
            setRow(rowData); setAction('single'); showDeleteModal()
          }} />
      </div>
    )
  }

  return (
    <>
      <Toast ref={toast} />
      <SkeletonTable load={loadPage}>
        <div className='surface-100 px-4 py-5 md:px-6 lg:px-8'>
          <div className="flex flex-row align-items-center justify-content-center mb-2 font-bold text-4xl mt-6">
            <span className="text-900">Kiosco</span>
          </div>
          <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-2xl mt-2">
            <span className="text-900">Internet: {isOnline ? 'ON' : 'OFF'}</span>
          </div>
          {!isAvailable && message && <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-xl mt-2">
            <span
              className="bg-primary text-white px-4 py-2 border-round-xl shadow-4 text-xl font-bold animate-bounce transition-all transition-duration-300"
            >
              Estado: {message}
            </span>
          </div>}
          {/* <div className="surface-100 px-4 py-5 md:px-6 lg:px-8"> */}
          <div className="mt-2">
            <Dialog header={header} visible={openLogin} position="center" style={{ width: "26rem" }} footer={loginFooter}
              draggable={false} resizable={false} modal onHide={hideModal}>
              <label className='mr-1'>Usuario</label><br />
              <InputText value={user} onChange={(e) => setUser(e.target.value)} style={{ width: '100%' }} /><br />
              <label className='mr-1'>Contraseña</label><br />
              <Password id="password" className='password' value={password} inputStyle={{ width: '100%' }} style={{ width: '100%' }} onChange={(e) => setPassword(e.target.value)} feedback={false} toggleMask />
            </Dialog>
            <Dialog header={header} visible={openSend} position="center" style={{ width: "26rem" }} footer={sendFooter}
              draggable={false} resizable={false} modal onHide={hideSendModal}>
              <label className='mr-1'>Usuario</label><br />
              <InputText value={user} onChange={(e) => setUser(e.target.value)} style={{ width: '100%' }} /><br />
              <label className='mr-1'>Contraseña</label><br />
              <Password id="password" className='password' value={password} inputStyle={{ width: '100%' }} style={{ width: '100%' }} onChange={(e) => setPassword(e.target.value)} feedback={false} toggleMask />
            </Dialog>
            <Dialog header={header} visible={openDelete} position="center" style={{ width: "26rem" }} footer={deleteFooter}
              draggable={false} resizable={false} modal onHide={hideDeleteModal}>
              <label className='mr-1'>Usuario</label><br />
              <InputText value={user} onChange={(e) => setUser(e.target.value)} style={{ width: '100%' }} /><br />
              <label className='mr-1'>Contraseña</label><br />
              <Password id="password" className='password' value={password} inputStyle={{ width: '100%' }} style={{ width: '100%' }} onChange={(e) => setPassword(e.target.value)} feedback={false} toggleMask />
            </Dialog>
            <Dialog header={sendConfirmHeader} visible={openSendConfirm} position="center" style={{ width: "26rem" }} footer={sendConfirmFooter}
              draggable={false} resizable={false} modal onHide={hideSendConfirmModal}>
            </Dialog>
            <Dialog header={deleteConfirmHeader} visible={openDeleteConfirm} position="center" style={{ width: "26rem" }} footer={deleteConfirmFooter}
              draggable={false} resizable={false} modal onHide={hideDeleteConfirmModal}>
            </Dialog>
            {/* <Button label="Capturar" icon="pi pi-camera" className="p-button mr-2 p-button-sm" onClick={showModalT} /> */}
            {!captured && <div className='flex flex-row w-full justify-content-center'>
              <div className="flex align-items-center">
                <Badge className="ml-2 mr-1" value="Entrada" size="medium" severity="success" />
                <Checkbox inputId="IN" value="IN" className='check-in'
                  onChange={(e) => {
                    setInChecked(e.checked)
                    if (outChecked) {
                      setOutChecked(false)
                    }
                    setDialingData({
                      ...dialingData,
                      INPUT: e.value
                    })
                  }}
                  checked={inChecked}
                />
              </div>
              <div className="flex align-items-center">
                <Badge className="ml-2 mr-1" value="Salida" size="medium" severity="danger" />
                <Checkbox inputId="OUT" value="OUT" className='check-out'
                  onChange={(e) => {
                    setOutChecked(e.checked)
                    if (inChecked) {
                      setInChecked(false)
                    }
                    setDialingData({
                      ...dialingData,
                      INPUT: e.value
                    })
                  }}
                  checked={outChecked}
                />
              </div>
            </div>}
            &nbsp;
            {(!manual && !dialingData.IMAGE || retry) &&

              <div className='flex flex-row justify-content-center'>
                <Webcam
                  audio={false}
                  height={450}
                  screenshotFormat="image/jpeg"
                  width={600}
                  videoConstraints={videoConstraints}
                >
                  {({ getScreenshot }) => (
                    <Button icon='pi pi-camera' tooltip='Tomar foto' disabled={!inChecked && !outChecked}
                      onClick={() => {
                        let imageSrc = getScreenshot({ width: 1920, height: 1080 })
                        if (tries < 3 && isOnline && isAvailable) {
                          console.log(isAvailable)
                          facialRecognition(imageSrc)
                        }
                        else {
                          setRetry(false)
                          let dateTime = getDateTime(new Date());
                          setDialingData({ ...dialingData, IMAGE: imageSrc, DATE: dateTime.DATE, TIME: dateTime.TIME })
                        }
                      }}
                    />
                  )}
                </Webcam>
              </div>
            }
            {dialingData.IMAGE && !retry && <div>
              <Image src={dialingData.IMAGE} alt='Tracking' width='600' height='450' />
              <div className='flex flex-column'>
                <span>Contrato: {dialingData.CONTRACT_ID} | Nombre: {dialingData.NAME} | PIN:  {dialingData.PIN}</span>
                <span>Fecha: {dialingData.DATE} | Hora: {dialingData.TIME}</span>
                <span>LAT: {latitud} | LON: {longitud}</span>
              </div>
            </div>
            }
            {
              (manual || tries >= 3 || (!isOnline && dialingData.IMAGE) || !isAvailable) &&
              <div className='mt-2 mb-2'>
                <label className='mr-1'>PIN</label>
                <InputText value={dialingData.PIN} onChange={(e) => setDialingData({ ...dialingData, PIN: e.target.value })} />
              </div>
            }
            <div>
              {(dialingData.IMAGE || manual) && !captured &&
                <>
                  <Button onClick={hideModalT} label='Cancelar' />
                  {!manual && <Button onClick={() => setRetry(true)} label='Reintentar' />}
                  <Button label='Aceptar' disabled={!dialingData.PIN} loading={loadCaptured} onClick={() => { postTrackingNovelty(dialingData) }} />
                </>}
            </div>
          </div>
          {rows.length > 0 &&
            <div className="mt-6">
              <SkeletonTable load={loadPage}>
                <DataTable className="card text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                  selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)}
                  dataKey="ID" header={header1} filters={filters1} filterDisplay="menu" globalFilterFields={['ID', 'PIN', 'DATE', 'TIME', 'INPUT']}>
                  <Column field="IMAGE" header="Foto" body={photoBodyTemplate}></Column>
                  <Column field="PIN" header="PIN" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por PIN" sortable></Column>
                  <Column field="DATE" header="Fecha" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha" sortable></Column>
                  <Column field="TIME" header="Hora" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por hora" sortable></Column>
                  <Column field="INPUT" header="Tipo" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tipo" sortable></Column>
                  <Column header="Acciones" headerStyle={{ width: '12rem', textAlign: 'center' }} body={actionBodyTemplate}></Column>
                </DataTable>
              </SkeletonTable>
            </div>}
          {/* </div> */}
        </div>
      </SkeletonTable>
    </>
  );
}

export default Kiosco
